/**
 *
 */
export const loggerDataKey = Symbol("logger-data");

/**
 *
 */
export const logExtFunctions = [
  "table",
  "group",
  "groupCollapsed",
  "groupEnd",
  "count",
  "clear",
  "profile",
  "profileEnd",
] as const satisfies (keyof Console)[];

/*                                                                        */
/*                                                                         */
declare global {
  interface Console {
    /**
 *
 *
 *
 *
 */
    profile: (profileName?: string) => void;
    /**
 *
 *
 *
 *
 */
    profileEnd: (profileName?: string) => void;
  }
}
